import React from "react";
import kebabCase from "lodash.kebabcase";
import { FormSpy } from "react-final-form";
import { TextField } from "@syos-music/form";
import { FieldRequiredError } from "@syos-music/form";

import { Grid } from "@mui/material";

export default function IntlUrlField({
  pathnamePrefix,
  regexp,
  name,
  label,
  ...props
}) {
  regexp = regexp || new RegExp(`^${pathnamePrefix}`);

  const validate = React.useCallback(
    (value) => {
      if (!props.required) return;

      if (props.required && !value?.replace(regexp, ""))
        return <FieldRequiredError />;
    },
    [props.required, regexp]
  );

  const parse = (value) =>
    pathnamePrefix +
    value
      .split("/")
      .map((chunk) => kebabCase(chunk))
      .join("/");

  const format = (value) =>
    (value || "")
      .replace(regexp, "")
      .split("/")
      .map((chunk) => kebabCase(chunk))
      .join("/");

  return (
    <FormSpy subscription={{ values: true }}>
      {({ form }) => {
        const frValue = form.getFieldState(`${name}.fr`)?.value;
        const enValue = form.getFieldState(`${name}.en`)?.value;

        return (
          <Grid container>
            <Grid item xs={12} md={6}>
              <TextField
                name={`${name}.fr`}
                label={
                  label && (
                    <>
                      <span role="img" aria-label="Français">
                        🇫🇷
                      </span>
                      &nbsp;{label}
                    </>
                  )
                }
                {...props}
                validate={validate}
                parse={parse}
                format={format}
                helperText={frValue && "/fr" + frValue}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                name={`${name}.en`}
                label={
                  label && (
                    <>
                      <span role="img" aria-label="English">
                        🇬🇧
                      </span>
                      &nbsp;{label}
                    </>
                  )
                }
                {...props}
                validate={validate}
                parse={parse}
                format={format}
                helperText={enValue && "/en" + enValue}
              />
            </Grid>
          </Grid>
        );
      }}
    </FormSpy>
  );
}
